import ApiClient from '@/api/ApiClient';

import type {
  Group,
} from '../models';

export class GroupClient {
  apiClient: ApiClient;

  constructor(apiClient?: ApiClient) {
    this.apiClient = apiClient || ApiClient.instance;
  }

  getGroups(request: { isVisible?: boolean; } = {}): Promise<Group[]> {
    const { ...params } = request;
    return this.apiClient.get({
      path: '/api/identity/groups',
      params,
    });
  }

  createGroup(request: { body?: Group; } = {}): Promise<void> {
    const { body } = request;
    return this.apiClient.post({
      path: '/api/identity/groups',
      body,
    });
  }

  updateGroup(request: { groupId: string; body?: Group; }): Promise<void> {
    const { groupId, body } = request;
    return this.apiClient.put({
      path: `/api/identity/groups/${groupId}`,
      body,
    });
  }

  deleteGroup(request: { groupId: string; }): Promise<void> {
    const { groupId } = request;
    return this.apiClient.del({
      path: `/api/identity/groups/${groupId}`,
    });
  }

  getGroupMemberships(request: { groupId: string; }): Promise<Record<string, string>[]> {
    const { groupId } = request;
    return this.apiClient.get({
      path: `/api/identity/groups/${groupId}/members`,
    });
  }

  addMemberships(request: { groupId: string; body?: string[]; }): Promise<void> {
    const { groupId, body } = request;
    return this.apiClient.post({
      path: `/api/identity/groups/${groupId}/members`,
      body,
    });
  }

  syncMemberships(request: { groupId: string; body?: string[]; }): Promise<void> {
    const { groupId, body } = request;
    return this.apiClient.post({
      path: `/api/identity/groups/${groupId}/members/sync`,
      body,
    });
  }

  addMembership(request: { groupId: string; userId: string; }): Promise<void> {
    const { groupId, userId } = request;
    return this.apiClient.post({
      path: `/api/identity/groups/${groupId}/members/${userId}`,
    });
  }

  deleteMembership(request: { groupId: string; userId: string; }): Promise<void> {
    const { groupId, userId } = request;
    return this.apiClient.del({
      path: `/api/identity/groups/${groupId}/members/${userId}`,
    });
  }
}

export default GroupClient;
